import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { RouterModule } from '@angular/router';
import { policiesRoutes } from './policies.routing';
import { PrivacyComponent } from './privacy/privacy.component';
import { DeletionComponent } from './deletion/deletion.component';

@NgModule({
    declarations: [TermsOfServiceComponent, PrivacyComponent, DeletionComponent],
    imports: [CommonModule, RouterModule.forChild(policiesRoutes)],
})
export class PoliciesModule {}
